/**
 * Created by jv on 2019-08-22 (11:36).
 */
import utils from "Sources/utils/utils";
import CONSTANTS from "Sources/config/constants";
import AppError from "Sources/models/app-error";

const log = require("Sources/utils/logger")();

let RoadUtils = {};

((RoadUtils) => {
  RoadUtils.pathToPoints = function (pathString, samples, samplePercentage) {
    let path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", pathString);

    let points = [];
    let len = path.getTotalLength();

    if (utils.isNull(samples) && utils.isNotNull(samplePercentage)) {
      samples = len * samplePercentage;
    }

    let step = len / samples;

    for (let i = 0; i <= len; i += step) {
      let p = path.getPointAtLength(i);
      points.push({x: p.x, y: p.y});
    }

    return points;
  };

  RoadUtils.getPathStringForNavigation = function (startPosition, navigations, endPosition, innerWidth, outerWidth) {
    /*
      Path commands (https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Paths):
      M = move to
      L = line to
        H = draw horizontal line (shorthand for horizontal only L, only 1 parameter)
        V = draw vertical line (shorthand for vertical only L, only 1 parameter)
      C = cubic curve (2 control points, 1 end point)
      Q = quadratic curve (1 control point, 1 end point)
     */

    let pathString = `M ${startPosition.x} ${startPosition.y}`;
    let currentPosition = {x: startPosition.x, y: startPosition.y};

    let curveBuffer = outerWidth / 2;

    for (let j = 0; j < navigations.length; j++) {
      let navigation = navigations[j];
      let nextNavigation = j < navigations.length - 1 ? navigations[j + 1] : null;

      if (utils.isNull(nextNavigation)) {
        nextNavigation = {
          // x: endPosition.x - currentPosition.x,
          // y: endPosition.y - currentPosition.y
          x: endPosition.x,
          y: endPosition.y,
          type: "absolute"
        };
      }

      let directionInfo = RoadUtils.getNavigationDirection(currentPosition, navigation, nextNavigation);

      if (navigation.type === "absolute") {
        currentPosition.x = navigation.x ? navigation.x : currentPosition.x;
        currentPosition.y = navigation.y ? navigation.y : currentPosition.y;
      } else {
        currentPosition.x += navigation.x;
        currentPosition.y += navigation.y;
      }

      // log.debug("DirectionInfo: %o\nCurrentPosition: %o", directionInfo, currentPosition);

      if (utils.isNotNull(directionInfo)) {
        if (directionInfo.currentDirection === CONSTANTS.DIRECTIONS.LEFT || directionInfo.currentDirection === CONSTANTS.DIRECTIONS.RIGHT) // Horizontal
        {
          if (directionInfo.currentDirection === CONSTANTS.DIRECTIONS.LEFT) {
            pathString += ` H ${currentPosition.x + curveBuffer}`;
            // currentPosition.x += curveBuffer;
          } else {
            pathString += ` H ${currentPosition.x - curveBuffer}`;
            // currentPosition.x -= curveBuffer;
          }

          if (directionInfo.nextDirection === CONSTANTS.DIRECTIONS.UP) {
            pathString += ` Q ${currentPosition.x} ${currentPosition.y} ${currentPosition.x} ${currentPosition.y - curveBuffer}`;
            // currentPosition.y -= curveBuffer;
          } else if (directionInfo.nextDirection === CONSTANTS.DIRECTIONS.DOWN) {
            pathString += ` Q ${currentPosition.x} ${currentPosition.y} ${currentPosition.x} ${currentPosition.y + curveBuffer}`;
            // currentPosition.y += curveBuffer;
          }
        } else if (directionInfo.currentDirection === CONSTANTS.DIRECTIONS.UP || directionInfo.currentDirection === CONSTANTS.DIRECTIONS.DOWN) // Vertical
        {
          if (directionInfo.currentDirection === CONSTANTS.DIRECTIONS.UP) {
            pathString += ` V ${currentPosition.y + curveBuffer}`;
            // currentPosition.y += curveBuffer;
          } else {
            pathString += ` V ${currentPosition.y - curveBuffer}`;
            // currentPosition.y -= curveBuffer;
          }

          if (directionInfo.nextDirection === CONSTANTS.DIRECTIONS.LEFT) {
            pathString += ` Q ${currentPosition.x} ${currentPosition.y} ${currentPosition.x - curveBuffer} ${currentPosition.y}`;
            // currentPosition.x -= curveBuffer;
          } else if (directionInfo.nextDirection === CONSTANTS.DIRECTIONS.RIGHT) {
            pathString += ` Q ${currentPosition.x} ${currentPosition.y} ${currentPosition.x + curveBuffer} ${currentPosition.y}`;
            // currentPosition.x += curveBuffer;
          }
        }
      } else // diagonal (currently not supported)
      {
        log.error("Unexpected road layout");
      }
    }

    pathString += ` L ${endPosition.x} ${endPosition.y}`;

    return pathString;
  };

  RoadUtils.getPathStringForNavigationOutline = function (startPosition, navigations, endPosition, outerWidth, strokeSide) {
    // left = if direction is DOWN, the left outline. This stays the same road for the other directions (eg. 180° flipped the direction is UP but the road is now the right outline)
    strokeSide = utils.isNullOrEmpty(strokeSide) ? "left" : strokeSide;
    let curveBuffer = outerWidth / 2;

    let currentNavigation = utils.isNotNull(navigations) && navigations.length > 0 ? navigations[0] : null;

    if (utils.isNull(currentNavigation)) {
      currentNavigation = {
        x: endPosition.x,
        y: endPosition.y,
        type: "absolute"
      };
    }

    let directionInfo = RoadUtils.getNavigationDirection(startPosition, currentNavigation, null);

    let pathString = "";
    let currentPosition = {x: startPosition.x, y: startPosition.y};

    if (directionInfo.currentDirection === CONSTANTS.DIRECTIONS.UP) {
      if (strokeSide === "left") {
        pathString = `M ${startPosition.x + curveBuffer} ${startPosition.y}`;
      } else {
        pathString = `M ${startPosition.x - curveBuffer} ${startPosition.y}`;
      }
    } else if (directionInfo.currentDirection === CONSTANTS.DIRECTIONS.RIGHT) {
      if (strokeSide === "left") {
        pathString = `M ${startPosition.x} ${startPosition.y + curveBuffer}`;
      } else {
        pathString = `M ${startPosition.x} ${startPosition.y - curveBuffer}`;
      }
    } else if (directionInfo.currentDirection === CONSTANTS.DIRECTIONS.DOWN) {
      if (strokeSide === "left") {
        pathString = `M ${startPosition.x - curveBuffer} ${startPosition.y}`;
      } else {
        pathString = `M ${startPosition.x + curveBuffer} ${startPosition.y}`;
      }
    } else if (directionInfo.currentDirection === CONSTANTS.DIRECTIONS.LEFT) {
      if (strokeSide === "left") {
        pathString = `M ${startPosition.x} ${startPosition.y - curveBuffer}`;
      } else {
        pathString = `M ${startPosition.x} ${startPosition.y + curveBuffer}`;
      }
    }

    for (let j = 0; j < navigations.length; j++) {
      let navigation = navigations[j];
      let nextNavigation = j < navigations.length - 1 ? navigations[j + 1] : null;

      if (utils.isNull(nextNavigation)) {
        nextNavigation = {
          x: endPosition.x,
          y: endPosition.y,
          type: "absolute"
        }
      }

      let directionInfo = RoadUtils.getNavigationDirection(currentPosition, navigation, nextNavigation);

      if (navigation.type === "absolute") {
        currentPosition.x = navigation.x ? navigation.x : currentPosition.x;
        currentPosition.y = navigation.y ? navigation.y : currentPosition.y;
      } else {
        currentPosition.x += navigation.x;
        currentPosition.y += navigation.y;
      }

      // log.debug("DirectionInfo: %o\nCurrentPosition: %o", directionInfo, currentPosition);

      if (utils.isNotNull(directionInfo)) {
        if (directionInfo.currentDirection === CONSTANTS.DIRECTIONS.LEFT || directionInfo.currentDirection === CONSTANTS.DIRECTIONS.RIGHT) // Horizontal
        {
          if (directionInfo.currentDirection === CONSTANTS.DIRECTIONS.LEFT) {
            if (directionInfo.nextDirection === CONSTANTS.DIRECTIONS.UP) {
              if (strokeSide === "left") // short side
              {
                pathString += ` H ${currentPosition.x + curveBuffer}`;
                pathString += ` Q ${currentPosition.x + curveBuffer} ${currentPosition.y - curveBuffer} ${currentPosition.x + curveBuffer} ${currentPosition.y - curveBuffer}`;
              } else // long side
              {
                pathString += ` H ${currentPosition.x}`;
                pathString += ` Q ${currentPosition.x - curveBuffer} ${currentPosition.y + curveBuffer} ${currentPosition.x} ${currentPosition.y}`;
              }
            } else {
              if (strokeSide === "left") // long side
              {
                pathString += ` H ${currentPosition.x}`;
                pathString += ` Q ${currentPosition.x - curveBuffer} ${currentPosition.y - curveBuffer} ${currentPosition.x + curveBuffer} ${currentPosition.y}`;
              } else // short side
              {
                pathString += ` H ${currentPosition.x + curveBuffer}`;
                pathString += ` Q ${currentPosition.x + curveBuffer} ${currentPosition.y + curveBuffer} ${currentPosition.x + curveBuffer} ${currentPosition.y + curveBuffer}`;
              }
            }
          } else {
            if (directionInfo.nextDirection === CONSTANTS.DIRECTIONS.UP) {
              if (strokeSide === "left") // long side
              {
                pathString += ` H ${currentPosition.x}`;
                pathString += ` Q ${currentPosition.x + curveBuffer} ${currentPosition.y + curveBuffer} ${currentPosition.x + curveBuffer} ${currentPosition.y}`;
              } else // short side
              {
                pathString += ` H ${currentPosition.x - curveBuffer}`;
                pathString += ` Q ${currentPosition.x - curveBuffer} ${currentPosition.y - curveBuffer} ${currentPosition.x - curveBuffer} ${currentPosition.y - curveBuffer}`;
              }
            } else {
              if (strokeSide === "left") // short side
              {
                pathString += ` H ${currentPosition.x - curveBuffer}`;
                pathString += ` Q ${currentPosition.x - curveBuffer} ${currentPosition.y + curveBuffer} ${currentPosition.x - curveBuffer} ${currentPosition.y + curveBuffer}`;
              } else // long side
              {
                pathString += ` H ${currentPosition.x}`;
                pathString += ` Q ${currentPosition.x + curveBuffer} ${currentPosition.y - curveBuffer} ${currentPosition.x + curveBuffer} ${currentPosition.y}`;
              }
            }
          }
        } else if (directionInfo.currentDirection === CONSTANTS.DIRECTIONS.UP || directionInfo.currentDirection === CONSTANTS.DIRECTIONS.DOWN) // Vertical
        {
          if (directionInfo.currentDirection === CONSTANTS.DIRECTIONS.UP) {
            if (directionInfo.nextDirection === CONSTANTS.DIRECTIONS.LEFT) {
              if (strokeSide === "left") // long side
              {
                pathString += ` V ${currentPosition.y}`;
                pathString += ` Q ${currentPosition.x + curveBuffer} ${currentPosition.y - curveBuffer} ${currentPosition.x} ${currentPosition.y - curveBuffer}`;
              } else // short side
              {
                pathString += ` V ${currentPosition.y + curveBuffer}`;
                pathString += ` Q ${currentPosition.x - curveBuffer} ${currentPosition.y + curveBuffer} ${currentPosition.x - curveBuffer} ${currentPosition.y + curveBuffer}`;
              }
            } else {
              if (strokeSide === "left") // short side
              {
                pathString += ` V ${currentPosition.y + curveBuffer}`;
                pathString += ` Q ${currentPosition.x + curveBuffer} ${currentPosition.y + curveBuffer} ${currentPosition.x + curveBuffer} ${currentPosition.y + curveBuffer}`;
              } else // long side
              {
                pathString += ` V ${currentPosition.y}`;
                pathString += ` Q ${currentPosition.x - curveBuffer} ${currentPosition.y - curveBuffer} ${currentPosition.x} ${currentPosition.y - curveBuffer}`;
              }
            }
          } else {
            if (directionInfo.nextDirection === CONSTANTS.DIRECTIONS.LEFT) {
              if (strokeSide === "left") // short side
              {
                pathString += ` V ${currentPosition.y - curveBuffer}`;
                pathString += ` Q ${currentPosition.x - curveBuffer} ${currentPosition.y - curveBuffer} ${currentPosition.x - curveBuffer} ${currentPosition.y - curveBuffer}`;
              } else // long side
              {
                pathString += ` V ${currentPosition.y}`;
                pathString += ` Q ${currentPosition.x + curveBuffer} ${currentPosition.y + curveBuffer} ${currentPosition.x} ${currentPosition.y + curveBuffer}`;
              }
            } else {
              if (strokeSide === "left") // long side
              {
                pathString += ` V ${currentPosition.y}`;
                pathString += ` Q ${currentPosition.x - curveBuffer} ${currentPosition.y + curveBuffer} ${currentPosition.x} ${currentPosition.y + curveBuffer}`;
              } else // short side
              {
                pathString += ` V ${currentPosition.y - curveBuffer}`;
                pathString += ` Q ${currentPosition.x + curveBuffer} ${currentPosition.y - curveBuffer} ${currentPosition.x + curveBuffer} ${currentPosition.y - curveBuffer}`;
              }
            }
          }
        }
      } else // diagonal (currently not supported)
      {
        log.error("Unexpected road layout");
      }
    }

    currentNavigation = {
      x: endPosition.x,
      y: endPosition.y,
      type: "absolute"
    };

    directionInfo = RoadUtils.getNavigationDirection(currentPosition, currentNavigation, null);

    log.debug("Final direction: %s", directionInfo.currentDirection);

    if (directionInfo.currentDirection === CONSTANTS.DIRECTIONS.UP) {
      if (strokeSide === "left") {
        pathString += ` L ${endPosition.x + curveBuffer} ${endPosition.y}`;
      } else {
        pathString += ` L ${endPosition.x - curveBuffer} ${endPosition.y}`;
      }
    } else if (directionInfo.currentDirection === CONSTANTS.DIRECTIONS.RIGHT) {
      if (strokeSide === "left") {
        pathString += ` L ${endPosition.x} ${endPosition.y + curveBuffer}`;
      } else {
        pathString += ` L ${endPosition.x} ${endPosition.y - curveBuffer}`;
      }
    } else if (directionInfo.currentDirection === CONSTANTS.DIRECTIONS.DOWN) {
      if (strokeSide === "left") {
        pathString += ` L ${endPosition.x - curveBuffer} ${endPosition.y}`;
      } else {
        pathString += ` L ${endPosition.x + curveBuffer} ${endPosition.y}`;
      }
    } else if (directionInfo.currentDirection === CONSTANTS.DIRECTIONS.LEFT) {
      if (strokeSide === "left") {
        pathString += ` L ${endPosition.x} ${endPosition.y - curveBuffer}`;
      } else {
        pathString += ` L ${endPosition.x} ${endPosition.y + curveBuffer}`;
      }
    }

    return pathString;
  };

  RoadUtils.getNavigationDirection = function (currentPosition, currentNavigation, nextNavigation) {
    let currentXTranslation;
    let currentYTranslation;

    // log.debug("Determining navigation direction\ncurrentPosition: %o\ncurrentNavigation: %o\nnextNavigation: %o", currentPosition, currentNavigation, nextNavigation);

    if (currentNavigation.type === "absolute") {
      currentXTranslation = currentNavigation.x ? (currentNavigation.x - currentPosition.x) : 0;
      currentYTranslation = currentNavigation.y ? (currentNavigation.y - currentPosition.y) : 0;
    } else {
      currentXTranslation = currentNavigation.x;
      currentYTranslation = currentNavigation.y;
    }

    let newX = currentPosition.x + currentXTranslation;
    let newY = currentPosition.y + currentYTranslation;

    let nextXTranslation;
    let nextYTranslation;

    if (utils.isNotNull(nextNavigation)) {
      if (nextNavigation.type === "absolute") {
        nextXTranslation = nextNavigation.x ? (nextNavigation.x - newX) : 0;
        nextYTranslation = nextNavigation.y ? (nextNavigation.y - newY) : 0;
      } else {
        nextXTranslation = nextNavigation.x;
        nextYTranslation = nextNavigation.y;
      }
    }

    // log.debug("currentPosition: %o\nnewX: %f\nnewY: %f\ncurrentXTranslation: %f\ncurrentYTranslation: %f\nnextXTranslation: %f\nnextYTranslation: %f", currentPosition, newX, newY, currentXTranslation, currentYTranslation, nextXTranslation, nextYTranslation);

    let currentDirection;
    let nextDirection;

    if (currentXTranslation !== 0 && currentYTranslation === 0) // Horizontal
    {
      currentDirection = currentXTranslation < 0 ? CONSTANTS.DIRECTIONS.LEFT : CONSTANTS.DIRECTIONS.RIGHT;
    } else if (currentXTranslation === 0 && currentYTranslation !== 0) // Vertical
    {
      currentDirection = currentYTranslation < 0 ? CONSTANTS.DIRECTIONS.UP : CONSTANTS.DIRECTIONS.DOWN;
    } else // Diagonal
    {
      log.error("Current direction is diagonal, this is currently not supported\nx translation: %f\ny translation: %f", currentXTranslation, currentYTranslation);
      return null;
    }

    if (utils.isNotNull(nextNavigation)) {
      if (nextXTranslation !== 0 && nextYTranslation === 0) // Horizontal
      {
        nextDirection = nextXTranslation < 0 ? CONSTANTS.DIRECTIONS.LEFT : CONSTANTS.DIRECTIONS.RIGHT;
      } else if (nextXTranslation === 0 && nextYTranslation !== 0) // Vertical
      {
        nextDirection = nextYTranslation < 0 ? CONSTANTS.DIRECTIONS.UP : CONSTANTS.DIRECTIONS.DOWN;
      } else // Diagonal
      {
        log.error("Next direction is diagonal, this is currently not supported\nx translation: %f\ny translation: %f", nextXTranslation, nextYTranslation);
        return null;
      }
    }

    return {
      currentDirection,
      nextDirection
    };
  };

  RoadUtils.combineConnections = function (connections) {
    if (utils.isNull(connections) || connections.length < 2) {
      throw new AppError({exception: new Error("At least 2 connections are required to combine")});
    }

    let startConnection = connections[0];

    let newConnection = {};

    newConnection.start = startConnection.start;
    newConnection.startType = startConnection.startType;
    newConnection.startPosition = startConnection.startPosition;

    newConnection.navigation = [];

    let lastNavigation;

    for (let i = 0; i < connections.length; i++) {
      let currentConnection = connections[i];

      if (newConnection.navigation.length > 0) {
        lastNavigation = newConnection.navigation[newConnection.navigation.length - 1];

        if (currentConnection.startPosition.x !== lastNavigation.x || currentConnection.startPosition.y !== lastNavigation.y) {
          log.error("Error while creating new connection. Navigation doesn't line up:\nlast navigation: %o\nnext start position: %o", lastNavigation, currentConnection.startPosition);
          return null;
        }
      }

      // Don't add startPosition of the connections to the new navigation, it should already be in there since the end position of the previous navigation should be equal to the start position of the next

      // Concat all navigations of the current connection to new connection
      newConnection.navigation = newConnection.navigation.concat(currentConnection.navigation);

      // If connection is the last set the end position instead of adding it to the navigation
      if (i === connections.length - 1) {
        newConnection.end = currentConnection.end;
        newConnection.endType = currentConnection.endType;
        newConnection.endPosition = {
          x: currentConnection.endPosition.x,
          y: currentConnection.endPosition.y
        };
      } else {
        // Add end position position as navigation part
        newConnection.navigation.push({
          x: currentConnection.endPosition.x,
          y: currentConnection.endPosition.y,
          type: "absolute"
        });
      }
    }

    return newConnection;
  };

  RoadUtils.getConnectionsForRoad = function (road, startKey, endKey, intersectionKeys, layoutData) {
    let connections = [];

    let start = startKey;
    let end;

    if (utils.isNotNull(intersectionKeys) && intersectionKeys.length > 0) {
      for (let i = 0; i < intersectionKeys.length; i++) {
        end = intersectionKeys[i];
        let currentConnection = getConnectionForStartAndEnd(start, end);

        if (utils.isNotNull(currentConnection)) {
          connections.push(currentConnection);
          // next start position is the current end position
          start = end;
        } else {
          log.error("No connection found for start [%s] and end [%s]", start, end);
          return null;
        }
      }
    }

    end = endKey;
    let currentConnection = getConnectionForStartAndEnd(start, end);

    if (utils.isNotNull(currentConnection)) {
      connections.push(currentConnection);
    } else {
      log.error("No connection found for start [%s] and end [%s]", start, end);
      return null;
    }

    function getConnectionForStartAndEnd(startKey, endKey) {
      for (let i = 0; i < road.connections.length; i++) {
        // Deep clone road connection since we might change some things
        let currentConnection = road.connections[i];

        if (currentConnection.start === startKey && currentConnection.end === endKey) {
          // Deep clone road connection since we might change some things (only clone once we found our connection, for performance)
          currentConnection = utils.parseJSON(utils.stringifyJSON(road.connections[i]));

          if (currentConnection.startType === "intersection") {
            let startIntersection = layoutData.intersections[startKey];

            if (utils.isNull(startIntersection)) {
              log.error("Intersection [%s] not found in layout data %o", startKey, layoutData);
            }

            currentConnection.startPosition = {
              x: startIntersection.position.x,
              y: startIntersection.position.y
            };
          }

          if (currentConnection.endType === "intersection") {
            let endIntersection = layoutData.intersections[endKey];

            if (utils.isNull(endIntersection)) {
              log.error("Intersection [%s] not found in layout data %o", startKey, layoutData);
            }

            currentConnection.endPosition = {
              x: endIntersection.position.x,
              y: endIntersection.position.y
            };
          }

          // Clone the connection because we might add some extra navigation
          return currentConnection;
        }
      }

      return null;
    }

    return connections;
  };
})(RoadUtils);

export default RoadUtils;



// WEBPACK FOOTER //
// ./app/js/components/business-model/road-utils.js